"use client";

import { useEffect } from "react";
import Link from "next/link";
import { Button } from "@/components/ui";
import {
  APP_ERROR_DESCRIPTION,
  APP_ERROR_HOME_LABEL,
  APP_ERROR_RETRY_LABEL,
  APP_ERROR_TITLE,
} from "@/constants/app-error";
import { noticeBrowserError } from "@/lib/newrelic/browser";

type AppErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function AppError({ error, reset }: AppErrorProps) {
  useEffect(() => {
    noticeBrowserError(error);
  }, [error]);

  return (
    <main className="flex min-h-[50vh] flex-col items-center justify-center gap-4 px-6 py-16 text-center">
      <h1 className="text-2xl font-semibold text-infoplaza-black dark:text-white">
        {APP_ERROR_TITLE}
      </h1>
      <p className="max-w-md text-sm text-zinc-600 dark:text-zinc-400">{APP_ERROR_DESCRIPTION}</p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Button variant="default" onClick={reset}>
          {APP_ERROR_RETRY_LABEL}
        </Button>
        <Button variant="outline" nativeButton={false} render={<Link href="/" />}>
          {APP_ERROR_HOME_LABEL}
        </Button>
      </div>
    </main>
  );
}
